<script>
/* global L : true*/
import { app_state, app_mgr, OnRemoveWaypoint, OnPathChanged, OnAddWaypoint } from './../../js/app_state'
import 'leaflet.heightgraph'

export default {
    name: "PathMixin",

    mounted() {
        OnAddWaypoint.push((wp) => { this.onAddWaypoint(wp); });
        OnRemoveWaypoint.push((_id) => { this.onRemoveWaypoint(_id); });
        OnPathChanged.push(() => { this.onPathChanged(); });
    },

    data() {
        return {
            markers: new Map(),
            waypoints: app_state.waypoints,
            pathLayer: null,
        }
    },

    methods: {
        onAddWaypoint(wp) {
            if (!this.markers.has(wp.id)) {
                let new_marker = L.marker(this.mymap.getCenter()).addTo(this.mymap);
                new_marker.setOpacity(0.0);
                new_marker.draggable = true;
                new_marker.dragging.enable();
                new_marker.riseOnHover = true;
                new_marker.on('drag', (evt) => { 
                    const latlng = evt.target.getLatLng();
                    app_mgr.setWaypointValues(wp.id, latlng.lng, latlng.lat);
                });
                new_marker.on('dragstart', () => {
                    this.is_dragging = true;
                });
                new_marker.on('dragend', () => {
                    this.is_dragging = false;
                });
                this.markers.set(wp.id, new_marker);
            }
            wp.addListener(() => { this.onChangedWaypoint(wp); })
        },

        onRemoveWaypoint(wp_id) {
            if (this.markers.has(wp_id)) {
                this.markers.get(wp_id).remove();
                this.markers.delete(wp_id);
            }
            this.computeMapZoomBound();
        },

        onChangedWaypoint(wp) {
            if (this.is_dragging) return;
            if (!this.markers.has(wp.id)) {
                this.onAddWaypoint(wp);
            }
            const marker = this.markers.get(wp.id);
            marker.setOpacity(1.0);
            marker.setLatLng(L.latLng([wp.lat, wp.lon]));
            this.computeMapZoomBound();
        },

        computeMapZoomBound() {
            if(app_state.waypoints.length <= 1) {
                this.mymap.setView([app_state.waypoints[0].lat, app_state.waypoints[0].lon], 13);
                return;
            }
            else if (typeof app_state.waypoints[0].lon != 'undefined') {
                let lng_max = app_state.waypoints[0].lon;
                let lng_min = app_state.waypoints[0].lon;
                let lat_max = app_state.waypoints[0].lat;
                let lat_min = app_state.waypoints[0].lat;
                for (const wp of app_state.waypoints) {
                    if (wp.lon > lng_max) {
                        lng_max = wp.lon;
                    }
                    if (wp.lon < lng_min) {
                        lng_min = wp.lon;
                    }
                    if (wp.lat > lat_max) {
                        lat_max = wp.lat;
                    }
                    if (wp.lat < lat_min) {
                        lat_min = wp.lat;
                    }
                }
                const max_bounds = [ [lat_max, lng_max],
                                    [lat_min, lng_min]];
                this.mymap.fitBounds(max_bounds);
            }
        },


        onPathChanged() {
            // clear current path:
            if (this.pathLayer != null) {
                this.pathLayer.clearLayers();
            }
    
            if(app_state.current_path.features_collection.length != 0) {                
                this.heightgraph.addTo(this.mymap);
                this.heightgraph.addData(app_state.current_path.features_collection);
                var _width = Math.min(window.innerWidth * 0.75, 800);
                var _height = Math.min(window.innerHeight * 0.4, 200);
                this.heightgraph.resize({width: _width, height: _height});
                L.geoJson(app_state.current_path.features_collection).addTo(this.pathLayer);
                this.mymap.fitBounds(this.pathLayer.getBounds());
            }
        },

        onResize () {
            if ( this.heightgraph != null && app_state.current_path.features_collection.length != 0) {
                var _width = Math.min(window.innerWidth * 0.75, 800);
                var _height = Math.min(window.innerHeight * 0.4, 200);
                this.heightgraph.resize({width: _width, height: _height});
            }
        }
    }
}
</script>


<style>
    @import "../../../node_modules/leaflet.heightgraph/dist/L.Control.Heightgraph.min.css";
</style>